import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import {ProcessSheets, Routing, TId} from 'src/app/models';

@Component({
    selector: 'app-routing-add',
    templateUrl: './routing-add.component.html',
    styleUrl: './routing-add.component.sass',
    standalone: false
})
export class RoutingAddComponent extends GenericCrudAddComponent<Routing> {

  @Input() processSheet?: ProcessSheets;
  override resource = this.api.resources.product.routings;

  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      code: [this.processSheet?.code || null],
      name: [this.processSheet?.name || null],
      documentTypeId:[this.processSheet?.documentTypeId || null],
      companyId: [this.api.auth.userValue?.lastCompanyId],
    });
    return group;
  }

  override onInitExtendActions(): void {
    setTimeout(() => this.form!.markAsDirty(), 0);
  }


}
